import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { MainOperatorRestrictionData } from "../../config/tableConfigs";
import MainOperatorRestrictionFormModal from "./components/MainOperatorRestrictionFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";
import { showMainToast } from "utils/showToast";

const MainOperatorRestrictionPage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/main_operator_action",
    MainOperatorRestrictionData,
    formdata,
    refresh
  );

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteMainOperatorRestriction");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  // ✅ Toggle is_active via TOGGLE action — no modal needed
  const handleToggle = async (row) => {
    try {
      const form = new FormData();
      form.append("action", "TOGGLE");
      form.append("id",     row.id);
      form.append("userid", userid);

      const res    = await fetch("https://pro.mokshiq.in/main_operator_action", {
        method : "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        body   : form,
      });
      const result = await res.json();

      if (result.status) {
        showMainToast(result.data, "success");
        setRefresh((prev) => prev + 1); // re-fetch table
      } else {
        showMainToast(result.data || "Toggle failed!", "danger");
      }
    } catch {
      showMainToast("Something went wrong!", "danger");
    }
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)) {
      console.log("Deleting:", selectedIds);
    }
  };

  const handleFormSuccess = () => {
    setRefresh((prev) => prev + 1);
    setModalShow(false);
  };

  const handleDeleteSuccess = () => {
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <PageWrapperForm
        config={MainOperatorRestrictionData}
        handleOnclick={handleAddUser}
        buttonTitle="Add Operator Restriction"
      >
        <DataTable
          config={MainOperatorRestrictionData}
          tableData={tableData}
          onView={undefined}          // no view needed
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onToggle={handleToggle}     
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      <MainOperatorRestrictionFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deleteMainOperatorRestriction"
        title="Delete Operator Restriction"
        message="Are you sure you want to delete this restriction?"
        apiUrl="https://pro.mokshiq.in/main_operator_action"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default MainOperatorRestrictionPage;